import { render, staticRenderFns } from "./StarOutline.vue?vue&type=template&id=585f4fd0"
import script from "./StarOutline.vue?vue&type=script&lang=js"
export * from "./StarOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports